// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  useLocalStorage : false,
  accessToken: '_zz7MgLZ7dqWxmoKzvLf', //TODO : make sure the access token is still valid.
  enableIntroDelay: false,

  downloadTable : true,

  enableCronJob: false,

  fetchDataEndPoint : 'http://localhost:3000/api/group',
  fetchDateLastFetchEndPoint: 'http://localhost:3000/api/group/time-last-fetch',
  checkBackend: 'http://localhost:3000/api/group/test'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
